import ApiService from './ApiService';

export default {
  getList() {
    return ApiService.get('/clients');
  },
  createClient(data) {
    return ApiService.post('/client', data);
  },
};